import {apiTaskToCreationSingleVoyage} from "@containers/singleVoyage/tasks/helpers/executions";
import React, {Suspense, useMemo, useState} from 'react';
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import ErrorBlock from "@ui/errors/errorBlock/ErrorBlock";
import {useTranslation} from 'react-i18next';
import MutateSingleVoyage from "@containers/singleVoyage/mutateVoyage/MutateSingleVoyage";
import {useGetByIdSingleVoyageQuery} from "@containers/singleVoyage/fetchingData/queryHooks/useSingleVoyagesQuery";
import {useGetTasksSingleVoyageQuery} from "@containers/singleVoyage/tasks/queryHooks/useTasksSingleVoyageQuery";
import {
    getInitialMutateVoyagePropsFromSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/helpers/getInitialMutateVoyagePropsFromSingleVoyage";
import {IRouteInfoSingleVoyage} from "@containers/singleVoyage/types/route";
import {IPositionSingleVoyage} from "@containers/singleVoyage/types/position";
import {IWayPointCreationWithCorrectionsSingleVoyage} from "@containers/singleVoyage/types/point";
import {
    useGetInitialAccountIdSingleVoyage
} from "@containers/singleVoyage/account/hooks/useGetInitialAccountIdSingleVoyage";

interface IProps {
    voyageId: string
}

const CreateFromHistorySingleVoyage = ({voyageId}: IProps) => {

    const {t} = useTranslation()

    const currentAccountId = useGetInitialAccountIdSingleVoyage()
    const [sourceAccountId] = useState<string>(currentAccountId)

    const {
        data,
        isLoading,
        isFetching,
        isError,
    } = useGetByIdSingleVoyageQuery({
        params: {
            voyageId,
            accountId: sourceAccountId
        },
        refetchOnMount: 'always'
    })

    const {
        data: tasks,
        isLoading: isLoadingGetTasks,
        isFetching: isFetchingGetTasks,
    } = useGetTasksSingleVoyageQuery({
        params: {
            voyageId,
            accountId: sourceAccountId
        }
    })


    const initial: {
        initialPositions: IPositionSingleVoyage[],
        initialPoints: IWayPointCreationWithCorrectionsSingleVoyage[],
        initialRouteInfo: IRouteInfoSingleVoyage,
    } = useMemo(() => {
        const res = getInitialMutateVoyagePropsFromSingleVoyage(data)
        return {
            ...res,
            initialRouteInfo: {
                ...res.initialRouteInfo,
                id: undefined,
                status: 'READY_FOR_MANUAL_RUN'
            },
            initialPoints: res?.initialPoints?.map((point) => {
                return {
                    ...point,
                    status: 'PLANNED'
                }
            })
        }
    }, [data])

    const initialTasksLocalCreateIds = useMemo(() => {
        if (!tasks?.length) {
            return []
        }
        return tasks?.map((task) => {
            return task.id
        })
    }, [tasks])

    if (
        isLoading ||
        isFetching ||
        isLoadingGetTasks ||
        isFetchingGetTasks
    ) {
        return (
            <SpinnerCustom
                variant={'fullScreen'}
            />
        )
    }

    if (!data?.id || isError) {
        return (
            <ErrorBlock
                message={t('singleVoyage.notFoundVoyage')}
            />

        )
    }

    return (
        <Suspense
            fallback={<SpinnerCustom/>}
        >
            <MutateSingleVoyage
                initialPositions={initial?.initialPositions}
                initialRouteInfo={initial?.initialRouteInfo}
                initialPoints={initial?.initialPoints}
                initialTasks={(tasks ?? []).map(apiTaskToCreationSingleVoyage)}
                initialTasksLocalCreateIds={initialTasksLocalCreateIds}
            />
        </Suspense>
    )
};

export default CreateFromHistorySingleVoyage;
